import React, { useState } from 'react';
import {
  SignupDetailsOne,
  SignupDetailsTwo,
  SignupDetailsThree,
} from '../../components/auth/SignupDetails';
import { Box, Typography, Stack } from '@mui/material';
import { AnimatePresence } from 'framer-motion';
import { useTheme } from '@mui/material/styles';
import { ButtonContainedLight } from '../../components/UIElements/button';
import { PATH_AUTH } from '../../routes/path';
import { useNavigate } from 'react-router-dom';
import { StatePageContainer } from '../../components/UIElements/pageUITransition';

const Signup: React.FC = () => {
  const theme = useTheme();
  const navigate = useNavigate();

  const [pageNumber, setPageNumber] = useState<number>(1);
  const [values, setValues] = useState({
    email: '',
    code: '',
    password: '',
    token: '',
  });
  const handlePage = () => {
    setPageNumber((prev) => prev + 1);
  };
  const handlePrevPage = () => {
    if (pageNumber === 1) {
      return;
    }
    setPageNumber((prev) => prev - 1);
  };

  const handleBackClick = () => {
    if (pageNumber === 1) {
      navigate(PATH_AUTH.signIn);
    } else {
      handlePrevPage();
    }
  };

  return (
    <Box
      sx={{
        background: 'white',
        paddingTop: 3,
      }}
    >
      <Stack
        direction={'column'}
        justifyContent={'space-between'}
        sx={{ margin: 3, gap: 4 }}
      >
        <Box>
          <ButtonContainedLight sx={undefined} onclick={handleBackClick}>
            Back
          </ButtonContainedLight>
        </Box>
        <AnimatePresence mode="wait">
          {pageNumber === 1 && (
            <StatePageContainer id="page1">
              <Box sx={{ width: '100%' }}>
                <Typography
                  color="primary"
                  variant="h2"
                  sx={{
                    fontWeight: 700,
                    fontFamily: 'DM Sans',
                    letterSpacing: '-0.23999999463558197px',
                  }}
                >
                  Get Started
                </Typography>
                <Typography
                  variant="h5"
                  sx={{ color: theme.palette.text.primary }}
                >
                  Join Managed medics
                </Typography>
              </Box>
            </StatePageContainer>
          )}
          {pageNumber === 2 && (
            <StatePageContainer id="page2">
              <Box sx={{ width: '100%' }}>
                <Typography
                  color="primary"
                  variant="h2"
                  sx={{
                    fontWeight: 700,
                    fontFamily: 'DM Sans',
                    letterSpacing: '-0.23999999463558197px',
                  }}
                >
                  Confirm Email
                </Typography>
                <Typography
                  variant="h5"
                  sx={{ color: theme.palette.text.secondary }}
                >
                  A 4 digit OTP has been sent to <br />
                  <span style={{ fontWeight: 600 }}> {values?.email}</span>
                </Typography>
              </Box>
            </StatePageContainer>
          )}

          {pageNumber === 3 && (
            <StatePageContainer id="page3">
              <Box sx={{ width: '100%' }}>
                <Typography
                  color="primary"
                  variant="h2"
                  sx={{
                    fontWeight: 700,
                    fontFamily: 'DM Sans',
                    letterSpacing: '-0.23999999463558197px',
                  }}
                >
                  Welcome to Managed Medics
                </Typography>
                <Typography
                  variant="h5"
                  sx={{ color: theme.palette.text.primary }}
                >
                  Join Managed medics
                </Typography>
              </Box>
            </StatePageContainer>
          )}
        </AnimatePresence>
        <AnimatePresence mode="wait">
          {pageNumber === 1 && (
            <StatePageContainer id="page1">
              <SignupDetailsOne
                values={values}
                changeValues={setValues}
                pageHandler={handlePage}
                prevPage={handlePrevPage}
              />
            </StatePageContainer>
          )}
          {pageNumber === 2 && (
            <StatePageContainer id="page2">
              <SignupDetailsTwo
                values={values}
                changeValues={setValues}
                pageHandler={handlePage}
                prevPage={handlePrevPage}
              />
            </StatePageContainer>
          )}
          {pageNumber === 3 && (
            <StatePageContainer id="page3">
              <SignupDetailsThree
                values={values}
                changeValues={setValues}
                pageHandler={handlePage}
                prevPage={handlePrevPage}
              />
            </StatePageContainer>
          )}
        </AnimatePresence>
      </Stack>
    </Box>
  );
};

export default Signup;
